import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Promotion',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Promotion',
        href: '/adm/promotion',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_promo',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'code',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'title',
        label: 'Title',
        sortable: true,
      },
      {
        key: 'start_date',
        label: 'Start',
        sortable: true,
      },
      {
        key: 'end_date',
        label: 'End',
        sortable: true,
      },
      {
        key: 'desc',
        label: 'Desc',
        sortable: true,
      },
      {
        key: 'status_info',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {},
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changePromotion(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchPromotion(context, params = null) {
    let result = await ApiGetRequest(`promotion`, params);
    return !result.error ? result.data.object : [];
  },

  async getListPromotion({ commit, state }) {
    commit('changePromotion', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`promotion`, params);
    commit('changePromotion', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailPromotion({ commit }, payload = null) {
    commit('changePromotion', {
      loading: true,
    });

    let result = await ApiGetRequest(`promotion/${payload.id}`);
    let result_obj = result.data.object;
    commit('changePromotion', {
      loading: false,
      detail: result.error
        ? false
        : {
            ...result_obj,
            start_date: result_obj.start_date
              ? moment(result_obj.start_date).format('DD/MM/YYYY')
              : '',
            end_date: result_obj.end_date
              ? moment(result_obj.end_date).format('DD/MM/YYYY')
              : '',
          },
    });

    return result.error ? false : true;
  },

  async uploadImagePromotion({ commit, state }, payload) {
    commit('changePromotion', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changePromotion', {
      loading: false,
    });

    if (!result.error) {
      commit('changePromotion', {
        form: {
          ...data.form,
          img_promo: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changePromotion', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`promotion/import`, {
      items: data.import_form || [],
    });

    commit('changePromotion', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createPromotion({ commit, state, dispatch }) {
    commit('changePromotion', {
      loading: true,
    });

    let result = await ApiPostRequest(`promotion`, state.data.form);
    commit('changePromotion', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updatePromotion({ commit, state, dispatch }, payload = null) {
    commit('changePromotion', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `promotion/${payload.id}`,
      state.data.form
    );

    commit('changePromotion', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePromotion({ commit, dispatch }, payload = null) {
    commit('changePromotion', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`promotion/${payload.id}`);
    commit('changePromotion', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
